import { AppState } from 'common/appState';

export const getViewSupplierSubscriptionView = (state: AppState) =>
    state.edit.viewSupplierSubscriptionView;
